import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "../styles/login.css";

function Login() {

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();

  const API = process.env.REACT_APP_API_URL;

  const handleSubmit = async (e) => {
  e.preventDefault();
  try {
    const response = await axios.post(`${API}/login`, {
      email: email,
      password: password
    });

    setMessage(response.data.message);

    if (response.data.message === "Login successful") {
      localStorage.setItem("token", response.data.token); // ← ADD THIS
      navigate("/dashboard");
    }

  } catch (error) {
    setMessage(error.response?.data?.message || "Server error");
  }
};

  return (
    <div className="login-container">

      {/* LEFT SIDE */}
      <div className="left-section">

        {/* TOP LEFT LOGO */}
        <img
          src="/assets/logo/inypeople_logo.png"
          alt="Logo"
          className="logo"
        />

        {/* CONTENT */}
        <div className="left-content">
          <h1>Welcome Back!</h1>
          <p>Sign in to your admin account</p>
          <div className="line"></div>

          {/* IMAGE */}
          <img
            src="/assets/images/login_img.png"
            alt="Login Illustration"
            className="illustration"
          />
        </div>
      </div>

      {/* RIGHT SIDE */}
      <div className="right-section">
        <div className="form-box">
          <h2>Admin Login</h2>
          <p className="sub-text">
            Enter your credentials to access the admin dashboard
          </p>

          <form onSubmit={handleSubmit}>

            {/* USERNAME */}
            <div className="input-group">
              <label>User Name</label>
              <div className="input-box">
                <span className="icon">
                  <img
                    src="/assets/images/log-user.png"
                    alt="email"
                    className="input-icon"
                  />
                </span>
                <input
                  type="text"
                  placeholder="User Name"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
            </div>

            {/* PASSWORD */}
            <div className="input-group">
              <label>Password</label>
              <div className="input-box">
                <span className="icon">
                  <img
                    src="/assets/images/log-pass.png"
                    alt="password"
                    className="input-icon"
                  />
                </span>
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="................"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <span
                  className="eye"
                  onClick={() => setShowPassword(!showPassword)}
                  style={{ cursor: "pointer" }}
                >
                  <img
                    src={showPassword ? "/assets/images/Eye_Open.png" : "/assets/images/log-eye.png"}
                    alt="eye"
                    className="eye-icon"
                  />
                </span>
              </div>
            </div>

         <div className="forgot"
  onClick={() => navigate("/admin/forgot-password")}
  style={{ cursor: "pointer" }}>
  Forgot Password?
</div>

            {/* BUTTON */}
            <button type="submit" className="signin-btn">
              Sign In
            </button>

          </form>

          {/* ERROR / SUCCESS MESSAGE */}
          {message && (
            <p className="login-message"
              style={{ color: message === "Login successful" ? "green" : "red" }}
            >
              {message}
            </p>
          )}

        </div>
      </div>

    </div>
  );
}

export default Login;